import http from "@/http/aisea/axios";
const resource = "/../secure_dataflow/m0";

export default {
    
    searchCheckList(vesselId, params) {
        return http.get(`${resource}/vessels/${vesselId}/m0checklists`, { params: params});
    },

    searchTrendData(vesselId, params) {
        return http.get(`${resource}/vessels/${vesselId}/m0checklists/search`, {
            params: params
        })
    },

    getVersions(vesselId, params) {
        return http.get(`${resource}/vessels/${vesselId}/m0checklists/versions`, {
            params: params
        })
    },

    getM0ChecklistHtml(m0ChecklistId) {
        return http.get(`${resource}/m0checklists/${m0ChecklistId}/export`);
    },
}
